export const attributes = ['aria-hidden', 'class-name', 'description', 'id', 'inversed', 'title', 'view-box'];